import React from 'react';
import useEpisodePlayersContext from '@mainHooks/useEpisodePlayersContext';
import usePlayersContext from '@playerHooks/usePlayersContext';

const Image = () => {
    const { data } = useEpisodePlayersContext();
    const { episodeIndex } = usePlayersContext();
    const { podcastImageUrl } = data;
    const { episodeTitle } = data.episodes[episodeIndex];
    const podcastData = data.episodes[episodeIndex];
    const imageUrl = podcastImageUrl ?? podcastData?.podcastImageUrl;
    const alt = (data?.podcastImageAlt ?? data.episodes[episodeIndex]?.podcastImageAlt) || episodeTitle;

    return <>{imageUrl && <img height={80} width={80} src={imageUrl} alt={alt ? alt : 'Featured Episode'} />}</>;
};

export default Image;
